import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ShareDialogReferralComponent } from '@app-modules/feature/my-referral/share-dialog-referral/share-dialog-referral.component';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ToastrService } from 'ngx-toastr';
import { MyactivityService } from 'src/app/core/services/myactivity.service';

@Component({
  selector: 'app-referral-dialog',
  templateUrl: './referral-dialog.component.html',
  styleUrls: ['./referral-dialog.component.css'],
})
export class ReferralDialogComponent implements OnInit, AfterViewInit {
  constructor(
    private _inviteService: InviteEarnService,
    private _toastr: ToastrService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private AchievementsService: MyactivityService,
    private dialogRef: MatDialogRef<ReferralDialogComponent>
  ) {}

  user: any;
  referralObj: any;
  textAreaLink: any;

  ngOnInit(): void {
    this.user = this._inviteService?.getUserInfo();
    this.saveReferralReminder();
  }

  ngAfterViewInit(): void {
    this.getRefCode(this.user?.userId, this.user?.name);
  }
  copyRefCode() {
    this._toastr?.success('Text Copied!');
    navigator?.clipboard?.writeText(this.referralObj?.deepLink);
  }

  getRefCode(userId: any, userName: any) {
    this._inviteService
      .generateReferralCode(userId, userName)
      .subscribe((data: any) => {
        this.referralObj = data;
        this.textAreaLink = this.referralObj?.deepLink;
        this.referralObj.deepLink = this._inviteService?.referralDeepLink(data?.discountCode,30,7,this.textAreaLink)
        // this.referralObj.deepLink =
        //   `Hi! Here’s a fun learning App with live classes, videos, flashcards, mock tests, instant doubt clarification and much more. Use my coupon *${data?.discountCode}* to get 30% off on all packages. Valid only for next 7 days.\n` +
        //   this.textAreaLink;
        this._inviteService?.setRefToLocalStorage(
          this.referralObj?.userReferralId,
          this.referralObj?.deepLink,
          this.textAreaLink
        );
      });
  }

  shareSocialdialog() {
    const config: MatDialogConfig = {
      panelClass: ['REF-share-dialog', 'UNFAPP-mweb-btmstiky-modal'],
      width: '380',
      data: {
        shareUrl: this.referralObj?.deepLink,
        userRferralId: this.referralObj?.userReferralId,
        textUrl: this.textAreaLink,
      },
    };
    const dialogRef = this.dialog?.open(ShareDialogReferralComponent, config);
  }

  sendModeOfShare(modeOfShare: any) {
    this._inviteService
      ?.sendModeOfShareDetails(modeOfShare, this.referralObj?.userReferralId)
      ?.subscribe((res) => {
        console.log(res);
      });
  }

  closeDialog() {
    this.dialogRef?.close();
  }

  saveReferralReminder() {
    this._inviteService
      ?.saveReferralRemider(this.data?.userId, {})
      ?.subscribe((res: any) => {});
  }
}
